exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".the_about_f1_img_body img{max-width:100%;height:auto;margin-bottom:24px;border-radius:10px}.the_about_f1_content_body{padding:16px 0 20px 0}.the_about_f2_content_body:first-child{padding:50px 0 0}.the_about_f2_content_body:last-child{padding:0 0 10px 0}@media (max-width:1200px){.the_about_f1_content_body{padding:0 0 40px 0}}", ""]);

// exports
